import useBranchId from "@/shared/hooks/useBranchId";
import useFormules from "@/shared/hooks/useFormules";
import { allDeliveryMethods, allSources } from "@/shared/utils/constant";
import {
  getQueryKey,
  orderStatuses,
} from "@/shared/v2/hooks/useOrdersQueryKey";
import { ordersQueryFn } from "@/shared/v2/queries/useOrdersQuery";
import { useQueries } from "@tanstack/react-query";

const useFormulesOrders = () => {
  const formules = useFormules();
  const branch = useBranchId();
  const formuleIds = formules?.map((formule) => formule.branch.id) ?? [];
  const formulesContainsBranch = formuleIds?.includes(branch) ?? false;

  const orders = useQueries({
    combine: (results) => {
      return {
        ...results,
        refetch: () => Promise.all(results.map((q) => q.refetch())),
        data: [
          results.flatMap((result) => result?.data?.[0] ?? []),
          results.flatMap((result) => result?.data?.[1] ?? []),
          results.flatMap((result) => result?.data?.[2] ?? []),
        ],
        isFetching: results.some((result) => result.isPending),
      };
    },
    queries: formules
      .filter(() => formulesContainsBranch)
      .map((formule) => ({
        queryKey: getQueryKey(
          formule.branch.id,
          allSources,
          allDeliveryMethods,
          orderStatuses
        ),
        queryFn: () =>
          ordersQueryFn(formule.branch.id, {
            hasOffset: 1,
            order_statuses: orderStatuses,
            sources: allSources,
            delivery_methods: allDeliveryMethods,
          }),
        staleTime: Infinity,
      })),
  });

  return { ...orders };
};
export default useFormulesOrders;
